export const ContactUsData = {
  heroData: {
    title: "Contact ",
    title2: "Us",
    subTitle: "Precision Engineering for Controlled Atmosphere Systems",
    imgUrl:
      "https://proresglovebox.com/wp-content/uploads/2025/02/IISc-MRC-Customised.jpg",
  },

  formData: {
    leftSection: {
      imgUrl:
        "https://proresglovebox.com/wp-content/uploads/2025/02/IISc-MRC-Customised.jpg",

      title: "Let’s Discuss Your Requirement",
      titleAlt: "Engineered Solutions. Reliable Support.",

      description:
        "Connect with our technical team for glovebox systems, custom engineering, accessories, or service support.",

      address:
        "ProRes Scientific Pvt. Ltd.,No. 362/5, Site No.5, Santhosh Layout, Kadabgere Cross, Bengaluru, Karnataka, India",
      mobileNUmber:
        "+91 98446 06132",
      mobileNumber2:"+91 96208 32434",
      emailAddress:
        "js@proresscientific.in",
      emailAddress2:"bharath@proresscientific.in"
    },
  },
};
